import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 3h7.5l-.5 4h-3v3h3v3.5h-3v6.5l-4 1l0 -18","key":"svg-0"}]]

const IconBrandFortnite = createReactComponent('outline', 'brand-fortnite', 'BrandFortnite', __iconNode);

export default IconBrandFortnite;